<template>
  <div class="container">
    <!-- :default-checked-keys="[orgdata[0].id]" 默认选中第一项 -->
    <el-tree
      :filter-node-method="filterNode"
      :expand-on-click-node="false"
      :check-on-click-node="true"
      :data="orgdata"
      show-checkbox
      node-key="id"
      default-expand-all
      :default-checked-keys="[orgdata[0].id]"
      :props="defaultProps"
      ref="orgTree"
      :check-strictly="true"
      @check="handleCheckChange"
    >
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "orgTree",
  data() {
    return {
      org_name: "机构名称",

      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {},
  props: {
    keyword: {
      type: String,
      default: "",
    },
    orgdata: {
      type: [Object, Array],
      default: () => {
        return [];
      },
    },
  },
  methods: {
    filterNode(value, data) {
      // 筛选节点
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data, e, l) {
      // console.log(data, "ddddddd") // 可以拿到描述信息
      this.$refs.orgTree.setCheckedKeys([data.id]);
      // 此处获取机构id并传递给detail组件
      this.$emit("setOrg", data.id, data);
    },
  },
  watch: {
    keyword: {
      handler(newV, oldV) {
        this.$nextTick(() => {
          this.$refs.orgTree.filter(newV);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  height: 100%;
}
</style>
